// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 53,
  argument: "A prayer for help in distress.",
  verses: [
    { n: 1, text: "Unto the end, in verses, understanding for David." },
    { n: 2, text: "When the men of Ziph had come and said to Saul: Is not David hidden with us? [." },
    { n: 3, text: "Save me, O God, by thy name, and judge me in thy strength." },
    { n: 4, text: "O God, hear my prayer: give ear to the words of my mouth." },
    { n: 5, text: "For strangers have risen up against me; and the mighty have sought after my soul; and they have not set God before their eyes." },
    { n: 6, text: "For behold God is my helper: and the Lord is the protector of my soul." },
    { n: 7, text: "Turn back the evils upon my enemies: and cut them off in thy truth." },
    { n: 8, text: "I will freely sacrifice to thee, and will give praise, O God, to thy name: because it is good:" },
    { n: 9, text: "For thou hast delivered me out of all trouble: and my eye hath looked down upon my enemies." },
  ],
  commentary: [
    { verse: 2, notes: [
      { text: "Ziph lay to the south of Juda. (Haydock) — David was rescued from the most imminent danger, by an irruption of the Philistines. He then composed this canticle, expressing his sentiments in danger, and his gratitude to God. (Calmet) — It may also be used by any person in distress. (Worthington) — The Church orders it to be said by her ministers at Prime, that they may be protected from all their spiritual enemies. (Berthier) — The Fathers apply it to Jesus Christ, (St. Hilary) or to his persecuted members.", attribution: "St. Augustine" }
    ] },
    { verse: 3, notes: [
      { text: "Name, which is a strong tower, (Proverbs xviii. 10.; Calmet) event thyself. Hence it is so criminal to take it in vain. (Berthier) — Judge. Ancient psalters have, \"deliver.\" Saul and the Zipheans persecute me unjustly. I commit my cause to thee. (Haydock) — Defend me for the justice of my cause.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Strangers. Barbarous, (Worthington) enemies, though of the same tribe. (Calmet) — Hostis dicebatur quem nunc peregrinum dicimus. (Cicero, Off. i.) — The devil and our passions, as well as the world, are such to us.", attribution: "Berthier" }
    ] },
    { verse: 6, notes: [
      { text: "Behold. He admires how God delivered him, though Saul seemed to have only one step more to take. Jesus Christ was secure amid the persecutions of the Jews, till he was pleased to deliver himself up, John x. 18.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Truth. To fulfil thy promises. (Haydock) — He foretells their destruction.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Freely, without being commanded. (Worthington) (Menochius) (Leviticus iii. 1.) — Jesus Christ was offered, because he would, Isaias liii. 7., and John x. 17. (St. Jerome) — Good, so to do, (Du Hamel) or sweet in itself, Psalm li. 11.", attribution: "Calmet" }
    ] },
    { verse: 9, notes: [
      { text: "Enemies, from the hill which divided the armies. I saw them retire, (Haydock) and in security beheld their chastisement.", attribution: "Menochius" }
    ] },
  ],
};

export default chapter;
